import {IAppBuilderTab} from "@AppBuilderLib/features/appbuilder/config/appbuilder";
import {useShapeDiverStoreStandardContainers} from "@AppBuilderLib/features/appbuilder/model/useShapeDiverStoreStandardContainers";
import TabsComponent, {
	ITabsComponentProps,
} from "@AppBuilderLib/shared/ui/tabs/TabsComponent";
import AppBuilderWidgetsWithStackShell from "@AppBuilderLib/widgets/appbuilder/ui/AppBuilderWidgetsWithStackShell";
import {useMemo} from "react";

interface Props {
	/**
	 * Default session namespace to use for parameter and export references that do
	 * not specify a session namespace.
	 */
	namespace: string;
	/** The tabs to display. */
	tabs: IAppBuilderTab[] | undefined;
	/** Optional name of the container. */
	containerName?: string;
	stickyTabs?: boolean;
}

export default function AppBuilderTabsComponent({
	namespace,
	tabs,
	containerName,
	stickyTabs = true,
}: Props) {
	const {setActiveTab} = useShapeDiverStoreStandardContainers();

	const tabProps: ITabsComponentProps | null = useMemo(() => {
		if (!tabs || tabs.length === 0) {
			return null;
		}

		return {
			defaultValue: tabs[0].name,
			stickyTabs,
			tabs: tabs.map((tab) => {
				return {
					name: tab.name,
					icon: tab.icon,
					tooltip: tab.tooltip,
					children: [
						<AppBuilderWidgetsWithStackShell
							key={0}
							namespace={namespace}
							widgets={tab.widgets}
						/>,
					],
				};
			}),
			onActiveTabChange: containerName
				? (tabIndex: number) => setActiveTab(containerName, tabIndex)
				: undefined,
		};
	}, [namespace, tabs, containerName, setActiveTab, stickyTabs]);

	if (!tabProps) {
		return <></>;
	}

	return <TabsComponent {...tabProps} />;
}
